export default __webpack_public_path__ + "static/media/Socicons-login-signup.0db299d2.svg";